export const PROPERTIES = {
    TODO: 'AddToDo',
    SPECIAL_DAY: 'SpecialDay',
    REQUEST_LEAVE: 'RequestLeave',
    REPORT_ILLNESS: 'ReportIllness',
    ADD_RECURRENT: 'AddRecurrent',
    SMALL_APPOINTMENTS: 'SmallAppointments'
};